// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base container for the Attendance Report component */
.attendance-report__wrapper {
  font-family: Arial, sans-serif;
  padding: 20px 10px;
  max-width: 900px;
  /* margin: 20px auto; */
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Title styling */
.attendance-report__title {
  color: #333;
  text-align: center;
  margin-bottom: 25px;
  font-size: 24px;
  font-weight: bold;
}

/* Instructions/Tip section */
.attendance-report__instructions {
  background-color: #e0f7fa;
  border-left: 5px solid #00bcd4;
  padding: 15px;
  margin-bottom: 25px;
  border-radius: 4px;
  color: #00796b;
}

.attendance-report__instructions p {
  margin: 0;
  line-height: 1.5;
}

/* Form layout for inputs */
.attendance-report__form-section {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns for inputs */
  gap: 20px; /* Space between grid items */
  margin-bottom: 30px;
}
#selectedMonth {
  padding: 12px;
  margin-top: 4px;
}
/* Individual form group (label + input/select) */
.attendance-report__form-group {
  display: flex;
  flex-direction: column;
}

.attendance-report__form-group label {
  margin-bottom: 8px;
  font-weight: bold;
  color: #555;
}

/* Styling for date inputs and select dropdowns */
.attendance-report__input,
.attendance-report__select {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box; /* Include padding in element's total width/height */
  width: 100%; /* Ensure they take full width of their group */
}

/* Focus styles for inputs/selects */
.attendance-report__input:focus,
.attendance-report__select:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* View Report Button styling */
.attendance-report__view-button {
  grid-column: span 2; /* Make button span both columns */
  padding: 12px 25px;
  background-color: rgb(132, 199, 174);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 15px;
}
.attendance-report__info-text{
  margin-bottom: 15px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color:#555;
}

.attendance-report__view-button:hover {
  background-color: rgb(97, 192, 159);
}

.attendance-report__view-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* Messages (error/info) */
.attendance-report__error-message {
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
}

.attendance-report__info-message {
  color: #004085;
  background-color: #cce5ff;
  border: 1px solid #b8daff;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
}
.attendance_view_tbn {
  width: 160px;
}
/* Attendance data table container */
.attendance-report__table-container {
  margin-top: 30px;
  overflow-x: auto; /* Allows horizontal scrolling for narrow screens */
}

.attendance-report__table-title {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

/* Table styling */
.attendance-report__table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}

.attendance-report__table thead {
  background-color: #e2e6ea;
}

.attendance-report__table th,
.attendance-report__table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap; /* Prevent text wrapping in cells */
}

.attendance-report__table th {
  font-weight: bold;
  color: #333;
}

.attendance-report__table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.attendance-report__table tbody tr:hover {
  background-color: #e9ecef;
}
.attendance-count-table-container {
  max-height: 75vh; /* or whatever fits your layout */
  overflow-y: auto; /* enable vertical scrolling */
  /* padding-bottom: 20px; */
  position: relative;
}

.attendance-count-table-container h3 {
  position: sticky;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .attendance-report__form-section {
    grid-template-columns: 1fr; /* Stack inputs on smaller screens */
  }
  .attendance-report__view-button {
    grid-column: span 1;
  }
}

.report_actionSetion {
  display: flex;
  margin-left: auto;
}
.report-Calculation-btn {
  border: 1px solid black;
  padding: 5px 10px;
  margin-right: 10px;
}

.editable-table {
  width: 100%;
  border-collapse: collapse;
  /* margin-top: 20px; */
  overflow-y: scroll;
  height: 250px;
}
/* .name-column{
  width: 25px;
} */
.editable-table th,
.editable-table td {
  border: 1px solid #ccc;
  padding: 0px;
  text-align: center;
}

.editable-table td[contenteditable="true"] {
  background-color: #f9f9f9;
  cursor: text;
}
.counterTableHeading {
  display: flex;
}

.Freeze_Checkbox {
  width: 40px;
  /* font-size: 15px; */
}
/* .attendance-count-table-container h3{
  margin: 0px 0px 10px 10px;
}
.attendance-count_top_left_container{
  display: flex;

} */
.attendance-count_filters {
  display: flex;
}
/* Scroll container for User-wise Attendance Summary */
.attendance-summary-scroll {
  max-height: 57vh;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
}
.attendance-summary-scroll thead th {
  position: sticky;
  top: 0;
  background: #deecdd; /* same as your table head background */
  z-index: 10;
  padding: 5px 22px;
  font-size: 12px;
  /* margin-top: 20px; */
}
.attendance-summary-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.attendance-summary-scroll::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 10px;
}

.attendance-summary-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* .attendance-count_top_container{
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
} */

.attendance-count_top_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px 5px 16px;
  gap: 20px;
}

.attendance-count_top_left_container {
  display: flex;
  align-items: center;
  gap: 18px; /* ✅ space between heading and filters */
}

.attendance-count_filters {
  display: flex;
  align-items: center;
  gap: 12px; /* ✅ space between dropdown + input */
}

.attendance-count_filters select {
  /* padding: 10px 14px; */
  border-radius: 6px;
  border: 1px solid #ccc;
  padding-top: 5px;
}

.attendance-count_filters input[type="search"] {
  /* padding: 9px 11px; */
  padding-top: 7px;

  width: 170px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.attendance-count_search {
  display: flex;
  /* background-color: rgb(132 199 174 / 67%); */
  margin-left: auto;
  padding: 4px 8px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: large;
}

.AttendanceSummary_header {
  display: flex;
}
.Attendance_Summary_dateRange {
  margin: 8px;
  font-size: x-small;
}

.LeaveAdjustment-popup-overlay {
  display: flex;
  flex-direction: column;

  height: auto;
  max-width: 60vw;
}
.LeaveAdjustment_close-btn button {
  font-size: 1.5rem;
}
.editLeaveBalance_header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1.5px solid rgba(128, 128, 128, 0.339);
  padding-bottom: 10px;
}
.editLeaveBalance_header h3 {
  font-weight: 400;
}
.LeaveAdjustment_headerName {
  display: flex;
  padding: 9px 0px 0px 0px;
}

.adjust_save_btn {
  /* border-top: 1px solid gray; */
  /* align-items: end; */
  display: flex;
  justify-content: end;
  && .adjust_save {
    border-radius: 8px;
    border: 1px solid #808080a1;
    padding: 3px 12px;
    margin-top: 12px;
    background-color: rgb(132 199 174 / 49%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/ReportsComponent/AttendanceReport.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B,EAAE,2BAA2B;EAC3D,SAAS,EAAE,6BAA6B;EACxC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,iDAAiD;AACjD;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAE,oDAAoD;EAC5E,WAAW,EAAE,+CAA+C;AAC9D;;AAEA,oCAAoC;AACpC;;EAEE,qBAAqB;EACrB,aAAa;EACb,gDAAgD;AAClD;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB,EAAE,kCAAkC;EACvD,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,gBAAgB,EAAE,mDAAmD;AACvE;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB,EAAE,iCAAiC;EACnD,gBAAgB,EAAE,8BAA8B;EAChD,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B,EAAE,oCAAoC;EAClE;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;AACA;;GAEG;AACH;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;;;;;;GAMG;AACH;EACE,aAAa;AACf;AACA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB,EAAE,uCAAuC;EAC5D,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,wCAAwC;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,qCAAqC;AAClD;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;;EAEhB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qDAAqD;EACrD,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;EAC1C;AACF","sourcesContent":["/* Base container for the Attendance Report component */\n.attendance-report__wrapper {\n  font-family: Arial, sans-serif;\n  padding: 20px 10px;\n  max-width: 900px;\n  /* margin: 20px auto; */\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Title styling */\n.attendance-report__title {\n  color: #333;\n  text-align: center;\n  margin-bottom: 25px;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n/* Instructions/Tip section */\n.attendance-report__instructions {\n  background-color: #e0f7fa;\n  border-left: 5px solid #00bcd4;\n  padding: 15px;\n  margin-bottom: 25px;\n  border-radius: 4px;\n  color: #00796b;\n}\n\n.attendance-report__instructions p {\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Form layout for inputs */\n.attendance-report__form-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two columns for inputs */\n  gap: 20px; /* Space between grid items */\n  margin-bottom: 30px;\n}\n#selectedMonth {\n  padding: 12px;\n  margin-top: 4px;\n}\n/* Individual form group (label + input/select) */\n.attendance-report__form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.attendance-report__form-group label {\n  margin-bottom: 8px;\n  font-weight: bold;\n  color: #555;\n}\n\n/* Styling for date inputs and select dropdowns */\n.attendance-report__input,\n.attendance-report__select {\n  padding: 10px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 1rem;\n  box-sizing: border-box; /* Include padding in element's total width/height */\n  width: 100%; /* Ensure they take full width of their group */\n}\n\n/* Focus styles for inputs/selects */\n.attendance-report__input:focus,\n.attendance-report__select:focus {\n  border-color: #007bff;\n  outline: none;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* View Report Button styling */\n.attendance-report__view-button {\n  grid-column: span 2; /* Make button span both columns */\n  padding: 12px 25px;\n  background-color: rgb(132, 199, 174);\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: 15px;\n}\n.attendance-report__info-text{\n  margin-bottom: 15px;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  color:#555;\n}\n\n.attendance-report__view-button:hover {\n  background-color: rgb(97, 192, 159);\n}\n\n.attendance-report__view-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n/* Messages (error/info) */\n.attendance-report__error-message {\n  color: #dc3545;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.attendance-report__info-message {\n  color: #004085;\n  background-color: #cce5ff;\n  border: 1px solid #b8daff;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n.attendance_view_tbn {\n  width: 160px;\n}\n/* Attendance data table container */\n.attendance-report__table-container {\n  margin-top: 30px;\n  overflow-x: auto; /* Allows horizontal scrolling for narrow screens */\n}\n\n.attendance-report__table-title {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n/* Table styling */\n.attendance-report__table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n}\n\n.attendance-report__table thead {\n  background-color: #e2e6ea;\n}\n\n.attendance-report__table th,\n.attendance-report__table td {\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  text-align: left;\n  white-space: nowrap; /* Prevent text wrapping in cells */\n}\n\n.attendance-report__table th {\n  font-weight: bold;\n  color: #333;\n}\n\n.attendance-report__table tbody tr:nth-child(even) {\n  background-color: #f8f9fa;\n}\n\n.attendance-report__table tbody tr:hover {\n  background-color: #e9ecef;\n}\n.attendance-count-table-container {\n  max-height: 75vh; /* or whatever fits your layout */\n  overflow-y: auto; /* enable vertical scrolling */\n  /* padding-bottom: 20px; */\n  position: relative;\n}\n\n.attendance-count-table-container h3 {\n  position: sticky;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .attendance-report__form-section {\n    grid-template-columns: 1fr; /* Stack inputs on smaller screens */\n  }\n  .attendance-report__view-button {\n    grid-column: span 1;\n  }\n}\n\n.report_actionSetion {\n  display: flex;\n  margin-left: auto;\n}\n.report-Calculation-btn {\n  border: 1px solid black;\n  padding: 5px 10px;\n  margin-right: 10px;\n}\n\n.editable-table {\n  width: 100%;\n  border-collapse: collapse;\n  /* margin-top: 20px; */\n  overflow-y: scroll;\n  height: 250px;\n}\n/* .name-column{\n  width: 25px;\n} */\n.editable-table th,\n.editable-table td {\n  border: 1px solid #ccc;\n  padding: 0px;\n  text-align: center;\n}\n\n.editable-table td[contenteditable=\"true\"] {\n  background-color: #f9f9f9;\n  cursor: text;\n}\n.counterTableHeading {\n  display: flex;\n}\n\n.Freeze_Checkbox {\n  width: 40px;\n  /* font-size: 15px; */\n}\n/* .attendance-count-table-container h3{\n  margin: 0px 0px 10px 10px;\n}\n.attendance-count_top_left_container{\n  display: flex;\n\n} */\n.attendance-count_filters {\n  display: flex;\n}\n/* Scroll container for User-wise Attendance Summary */\n.attendance-summary-scroll {\n  max-height: 57vh;\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: #fff;\n}\n.attendance-summary-scroll thead th {\n  position: sticky;\n  top: 0;\n  background: #deecdd; /* same as your table head background */\n  z-index: 10;\n  padding: 5px 22px;\n  font-size: 12px;\n  /* margin-top: 20px; */\n}\n.attendance-summary-scroll::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.attendance-summary-scroll::-webkit-scrollbar-thumb {\n  background: #aaa;\n  border-radius: 10px;\n}\n\n.attendance-summary-scroll::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* .attendance-count_top_container{\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 7px;\n} */\n\n.attendance-count_top_container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 16px 5px 16px;\n  gap: 20px;\n}\n\n.attendance-count_top_left_container {\n  display: flex;\n  align-items: center;\n  gap: 18px; /* ✅ space between heading and filters */\n}\n\n.attendance-count_filters {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* ✅ space between dropdown + input */\n}\n\n.attendance-count_filters select {\n  /* padding: 10px 14px; */\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  padding-top: 5px;\n}\n\n.attendance-count_filters input[type=\"search\"] {\n  /* padding: 9px 11px; */\n  padding-top: 7px;\n\n  width: 170px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n\n.attendance-count_search {\n  display: flex;\n  /* background-color: rgb(132 199 174 / 67%); */\n  margin-left: auto;\n  padding: 4px 8px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: large;\n}\n\n.AttendanceSummary_header {\n  display: flex;\n}\n.Attendance_Summary_dateRange {\n  margin: 8px;\n  font-size: x-small;\n}\n\n.LeaveAdjustment-popup-overlay {\n  display: flex;\n  flex-direction: column;\n\n  height: auto;\n  max-width: 60vw;\n}\n.LeaveAdjustment_close-btn button {\n  font-size: 1.5rem;\n}\n.editLeaveBalance_header {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1.5px solid rgba(128, 128, 128, 0.339);\n  padding-bottom: 10px;\n}\n.editLeaveBalance_header h3 {\n  font-weight: 400;\n}\n.LeaveAdjustment_headerName {\n  display: flex;\n  padding: 9px 0px 0px 0px;\n}\n\n.adjust_save_btn {\n  /* border-top: 1px solid gray; */\n  /* align-items: end; */\n  display: flex;\n  justify-content: end;\n  && .adjust_save {\n    border-radius: 8px;\n    border: 1px solid #808080a1;\n    padding: 3px 12px;\n    margin-top: 12px;\n    background-color: rgb(132 199 174 / 49%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
